import { Component, HostListener } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { CommonModule } from '@angular/common';
import { FooterComponent } from '../footer/footer.component';
import { HttpClient, HttpClientModule, HttpHeaders } from "@angular/common/http";
import { RouterModule } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { MetaTagService } from '../meta-tag.service';
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';
@Component({
  selector: 'app-about-us',
  standalone: true,
  imports: [HeaderComponent,CommonModule, FooterComponent,HttpClientModule,RouterModule,IconsFreeToolsComponent],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.css'
})
export class AboutUsComponent {
  constructor(private metaTagService: MetaTagService ){}
  shouldShowButton: boolean = false;
  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.pageYOffset > 200) {
      this.shouldShowButton = true;
    } else {
      this.shouldShowButton = false;
    }
  }
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  ngOnInit(): void {
    this.metaTagService.updateTags("About GrammarIn – Driven by Values, Led by Innovation",
       "Get to know GrammarIn – a passionate team with a commitment to quality, innovation, and customer satisfaction.",
       "https://www.grammarin.com/about-us");
}
// array

helpingToolsData = [
  { value: '2019', label: 'Year of Est.', icon: 'yearOfEstIcon' },
  { value: '20+', label: 'Languages', icon: 'aboutLanguagesIcon' },
  { value: '125+', label: 'No. of People Contribute', icon: 'peopleContributeIcon' }
];
}
